export default "__VITE_ASSET__da9b9095__"